/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Custom_Properties_Edit_Key_Display_NameInputs */

const en_forms_custom_properties_edit_key_display_name = /** @type {(inputs: Forms_Custom_Properties_Edit_Key_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Display Name`)
};

const de_forms_custom_properties_edit_key_display_name = /** @type {(inputs: Forms_Custom_Properties_Edit_Key_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel Angezeigter Name`)
};

/**
* | output |
* | --- |
* | "Key Display Name" |
*
* @param {Forms_Custom_Properties_Edit_Key_Display_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_custom_properties_edit_key_display_name = /** @type {((inputs?: Forms_Custom_Properties_Edit_Key_Display_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Custom_Properties_Edit_Key_Display_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_custom_properties_edit_key_display_name(inputs)
	return de_forms_custom_properties_edit_key_display_name(inputs)
});